var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _connector;
import { subscription } from '@1hive/connect-core';
export default class DisputableApp {
    constructor(data, connector) {
        _connector.set(this, void 0);
        __classPrivateFieldSet(this, _connector, connector);
        this.id = data.id;
        this.address = data.address;
        this.agreementId = data.agreementId;
        this.currentCollateralRequirementId = data.currentCollateralRequirementId;
        this.activated = data.activated;
    }
    async collateralRequirement() {
        return __classPrivateFieldGet(this, _connector).collateralRequirement(this.currentCollateralRequirementId);
    }
    onCollateralRequirement(callback) {
        return subscription(callback, (callback) => __classPrivateFieldGet(this, _connector).onCollateralRequirement(this.currentCollateralRequirementId, callback));
    }
}
_connector = new WeakMap();
